<script lang="ts" setup>
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const regleField =
        orderStore.validation.r$.$fields.toggleableFields.customerRemark;
</script>

<template>
    <shared-labeled-field
        v-if="orderStore.options.toggleableFields.customerRemark?.enabled"
        v-slot="{ ariaLabelledby }"
        :label="
            $t('checkout.customerRemark.label') +
            (orderStore.options.toggleableFields.customerRemark.required
                ? ' *'
                : '')
        "
    >
        <VTextarea
            v-model="orderStore.currentOrder.toggleableFields.customerRemark"
            :aria-labelledby="ariaLabelledby"
            :placeholder="$t('checkout.customerRemark.placeholder')"
            :error-messages="regleField?.$errors"
            @focusout="regleField?.$touch"
        />
    </shared-labeled-field>
</template>
